import { createLucideIcon } from 'lucide-react';

const TreeDownRightIcon = createLucideIcon('TreeDownRight', [
  [
    'path',
    {
      d: 'M4 2V9C4 10.0609 4.42143 11.0783 5.17157 11.8284C5.92172 12.5786 6.93913 13 8 13H20',
      key: '1',
    },
  ],
]);

TreeDownRightIcon.displayName = 'TreeDownRightIcon';

export default TreeDownRightIcon;
